export default "__VITE_ASSET__90151b5a__"